import * as React from 'react';

import type { WorkOrderTableViewModel } from 'ab-viewModels/workOrderTable.viewModel';

import type TableNameEnum from 'ab-enums/tableName.enum';

import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import type { BreadcrumbItem } from 'af-components/Breadcrumbs';
import Breadcrumbs from 'af-components/Breadcrumbs';

import ResourceHeader from './ResourceHeader';
import ResourceWorkOrders from './ResourceWorkOrders';
import styles from './styles.module.scss';

interface BaseProps {
	includeRelatedWorkOrders: boolean;
	headerTitle: string;
	companyName: string;
	renderHeaderButtons: () => React.JSX.Element;
	renderBody: () => React.JSX.Element | null;
	breadcrumbs: BreadcrumbItem[];
}

interface BasePropsWithoutRelatedWorkOrders extends BaseProps {
	includeRelatedWorkOrders: false;
}

interface BasePropsWithRelatedWorkOrders extends BaseProps {
	includeRelatedWorkOrders: true;
	tableName: TableNameEnum;
	fetchRelatedWorkOrders: (tableRequestModel: TableQuery, startDate: Date, endDate: Date) => Promise<TableResult<WorkOrderTableViewModel>>;
	csvName: string;
}

type OwnProps = BasePropsWithoutRelatedWorkOrders | BasePropsWithRelatedWorkOrders;

type Props = OwnProps;

const ResourcePreview: React.FC<Props> = (props) => {
	const { companyName, renderHeaderButtons, breadcrumbs, renderBody, headerTitle, includeRelatedWorkOrders } = props;

	return (
		<>
			<Breadcrumbs items={breadcrumbs} />
			<div className={styles['resource-container']}>
				<ResourceHeader renderButtons={renderHeaderButtons} title={headerTitle} />
				{renderBody()}
				{includeRelatedWorkOrders &&
					<ResourceWorkOrders
						companyName={companyName}
						csvName={props.csvName}
						findRelatedWorkOrders={props.fetchRelatedWorkOrders}
						tableName={props.tableName}
					/>
				}
			</div>
		</>
	);
};

export default React.memo(ResourcePreview);
